import { atom } from 'jotai';

// Module-scoped via Jotai so the choice survives the composer unmounting between phases.
export const selectedMicDeviceIdAtom = atom<string | null>(null);
